import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

import { ProductSubcategoriesDto } from '@app/core/types/product-subcategories.dto';

@Injectable({ providedIn: 'root' })
export class DpProductSubcategoriesApiService {
  readonly #httpClient = inject(HttpClient);
  readonly #occEndpoints = inject(OccEndpointsService);

  getSubcategoriesById(productCatalog: string, categoryId?: string): Observable<ProductSubcategoriesDto> {
    const url = this.#occEndpoints.buildUrl('productSubcategories', {
      urlParams: { productCatalog },
      queryParams: { categoryId }
    });
    return this.#httpClient.get<ProductSubcategoriesDto>(url);
  }
}
